import React, { useContext } from 'react';
import * as firebase from "firebase/app";
import "firebase/auth";
import firebaseConfig from '../firebaseConfig';
import { useHistory, useLocation } from 'react-router-dom';
import { UserContext } from '../../App';

if (firebase.apps.length === 0) {
    firebase.initializeApp(firebaseConfig);
}

const Google = () => {
    const [loggedInUser, setLoggedInUser] = useContext(UserContext);
    let history = useHistory();
    let location = useLocation();
    let { from } = location.state || { from: { pathname: "/" } };
    const handleGoogleSignIn = () => {
        const googleProvider = new firebase.auth.GoogleAuthProvider();
        firebase.auth().signInWithPopup(googleProvider)
            .then(result => {
                const { email } = result.user;
                const signedInUser = { email };
                setLoggedInUser(signedInUser);
                // console.log(result.user);
                history.replace(from);
            })
            .catch(error => {
                console.log(error.code);
                console.log(error.message);
            });
    }
    // const handleGoogleSignOut = () => {
    //     firebase.auth().signOut()
    //         .then(() => {
    //             console.log("Sign-out successful.");
    //         })
    //         .catch(error => {
    //             console.log("An error happened.");
    //         });
    // }
    return (
        <div>
            <button className="btn btn-primary" onClick={handleGoogleSignIn}>Continue with Google</button>
            {/* <button className="btn btn-secondary" onClick={handleGoogleSignOut}>Sign out from Google</button> */}
        </div>
    );
};

export default Google;